import type { StatAxis } from "./FriendsBoard";

// Стороны игры в квадрате сравнения: углы по часовой стрелке от верхнего левого.
export const SIDE_AXES: readonly StatAxis[] = ["aggression", "farm", "teamwork", "survival"];
